__turbopack_context__.v({
  "isCrypto": "MKtvoW_isCrypto",
  "isSticky": "MKtvoW_isSticky",
  "noTabs": "MKtvoW_noTabs",
  "quoteHeaderWrapper": "MKtvoW_quoteHeaderWrapper",
  "quoteTabsSticky": "MKtvoW_quoteTabsSticky",
  "simple": "MKtvoW_simple",
  "tabsSentinel": "MKtvoW_tabsSentinel",
});
